import { Button, Layout, Typography, useAlert } from "matsuri-ui"
import { css } from "@emotion/react"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { Link, useNavigate } from "react-router-dom"
import { useOperationInfoCtx } from "../providers/context"
import {
    requestFinishOperation,
    requestStartOperation
} from "@/hooks/useOperaion"
import { useTaskAfterTodayConfirm } from "@/hooks/useTaskAfterTomorrowConfirm"
import { useOperationIsReadyToStart } from "@/hooks/useIsReadyToStartCleaning"
import { useTranslation } from "@/hooks/useTranslation"

export const InfoFooter = () => {
    const { t } = useTranslation()
    const { token } = useAuth()
    const { operationId, operation, refetch } = useOperationInfoCtx()
    const navigate = useNavigate()

    const { throwAlert } = useAlert()
    const { confirmTaskIsAfterToday } = useTaskAfterTodayConfirm()

    const { data: operationIsReadyToStart } = useOperationIsReadyToStart({
        operationId
    })

    const isStartable = operationIsReadyToStart?.isReady ?? false

    const confirmEndTour = t("作業を終了しツアーを開始します。よろしいですか？")

    return (
        <div
            css={css`
                position: fixed;
                right: 0;
                bottom: 0;
                left: 0;
                display: flex;
                justify-content: space-between;
                padding: 16px 16px 34px 16px;
                background-color: rgba(255, 255, 255, 0.55);
                border-top: 1px solid #ffffff;
                backdrop-filter: blur(12px);
            `}
        >
            {operation?.status === "prepared" && (
                <Layout.Column gap={1}>
                    {!isStartable && (
                        <div>
                            <Typography variant="h4" align="center" as="h4">
                                {t("承認を完了してください！")}
                                <Link
                                    css={css`
                                        margin-left: 8px;
                                        color: black;
                                        text-decoration: underline;
                                    `}
                                    to="/approval_requests"
                                >
                                    {t("承認一覧へ")}
                                </Link>
                            </Typography>
                        </div>
                    )}
                    <div>
                        <div
                            css={css`
                                // Buttonのdisabled時にボタン色はopactiyで制御しているため、
                                // ここで背景色を指定している
                                background-color: white;
                                border-radius: 4px;
                            `}
                        >
                            <Button
                                disabled={!isStartable}
                                fullWidth
                                variant={"filled"}
                                color={"primary"}
                                onClick={async () => {
                                    const taskDate = operation?.cleaningDate
                                    if (!taskDate) return

                                    const confirmed = confirmTaskIsAfterToday({
                                        taskDate
                                    })

                                    if (!confirmed) return

                                    const { error } =
                                        await requestStartOperation(
                                            token,
                                            operationId
                                        )

                                    throwAlert(error, {
                                        errorMessage: t("開始に失敗しました"),
                                        ignoreSuccess: true,
                                        onSuccess: refetch
                                    })
                                }}
                            >
                                {t("作業を開始する")}
                            </Button>
                        </div>
                    </div>
                </Layout.Column>
            )}
            {operation?.status === "started" && (
                <Button
                    fullWidth
                    variant={"filled"}
                    color={"secondary"}
                    onClick={async () => {
                        const ok = window.confirm(confirmEndTour)
                        if (!ok) {
                            return
                        }

                        const { error } = await requestFinishOperation(
                            token,
                            operationId
                        )

                        throwAlert(error, {
                            errorMessage: t("終了に失敗しました"),
                            ignoreSuccess: true,
                            onSuccess: () => {
                                navigate(`/tour/${operationId}/photo/item/0`)
                            }
                        })
                    }}
                >
                    {t("作業を終了する")}
                </Button>
            )}
            {operation?.status === "finished" && (
                <Button
                    fullWidth
                    variant="filled"
                    onClick={() =>
                        navigate(`/tour/${operationId}/photo/item/0`)
                    }
                >
                    {t("報告を再開する")}
                </Button>
            )}
        </div>
    )
}
